<template>
    <div class="element">
        <v-text-field v-model="room.name" v-if="hasField('NAME')" label="Nom" outlined>
        </v-text-field>

        <v-textarea class="textarea" v-if="hasField('ROOM_DESCRIPTION')" label="Description" v-model="room.description"
            outlined>
        </v-textarea>

        <div class="d-flex justify-content-between flex-wrap">
            <v-text-field label="Capacité maximale (nb personnes)" v-if="hasField('MAX_CAPACITY_PERS')" class="mr-sm-4"
                type="number" v-model="room.max_capacity" :min="0" outlined>
            </v-text-field>

            <v-text-field label="Superficie (m²)" v-if="hasField('AREA')" v-model="room.area" type="number" :min="0" outlined>
            </v-text-field>

            <v-text-field label="Hauteur de plafond (m)" v-if="hasField('ROOM_HEIGHT')" class="ml-md-4 ml-sm-0"
                v-model="room.height" type="number" step="0.1" :min="0" outlined>
            </v-text-field>
        </div>

        <v-checkbox v-model="room.natural_light" v-if="hasField('NATURAL_LIGHT')" label="Lumière naturelle" class="mt-0"
            hide-details>
        </v-checkbox>

        <h5 style="font-size: 17px" class="mt-4 mb-5" v-if="hasRoomCapacitiesToDisplay()">
            Capacités par disposition
        </h5>

        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/U.png" class="mr-2"></v-img>

                <v-text-field label="En U" v-if="hasField('ROOM_U')" type="number" v-model="room.u_shape_capacity"
                              :min="0" outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/banquet.png" class="mr-2"></v-img>

                <v-text-field label="En banquet" v-if="hasField('ROOM_BANQUET')" type="number"
                    v-model="room.banquet_capacity" :min="0" outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/carre.png" class="mr-2"></v-img>

                <v-text-field label="En carré" v-if="hasField('ROOM_SQUARE')" type="number"
                    v-model="room.square_capacity" :min="0" outlined>
                </v-text-field>
            </div>
        </div>

        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/classe.png" class="mr-2"></v-img>

                <v-text-field label="En classe" v-if="hasField('ROOM_CLASS')" type="number"
                    v-model="room.classroom_capacity" :min="0" outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/cocktail.png" class="mr-2"></v-img>

                <v-text-field label="En cocktail" v-if="hasField('ROOM_COCKTAIL')" type="number"
                    v-model="room.cocktail_capacity" :min="0" outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/theatre.png" class="mr-2"></v-img>

                <v-text-field label="En théatre" v-if="hasField('ROOM_THEATRE')" type="number"
                    v-model="room.theatre_style_capacity" :min="0" outlined>
                </v-text-field>
            </div>
        </div>

        <div class="text-center w-100">
            <v-btn color="error" @click="removeRoom(index)">Supprimer</v-btn>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import Confirm from "@/components/tools/Confirm"

export default {
    name: "Room",
    components: { Confirm },
    props: ['room', 'index'],
    methods: {
        ...mapMutations('web_form', ['deleteRoom']),
        hasRoomCapacitiesToDisplay() {
            return this.hasField('ROOM_U') ||
                this.hasField('ROOM_BANQUET') ||
                this.hasField('ROOM_SQUARE') ||
                this.hasField('ROOM_CLASS') ||
                this.hasField('ROOM_COCKTAIL') ||
                this.hasField('ROOM_THEATRE')
        },
        removeRoom(index) {
            let message = 'Vous allez supprimer la salle'

            if (this.provider.room_renting.rooms[index].name !== null) {
                message += ' <b>' + this.provider.room_renting.rooms[index].name + '</b>'
            }

            message += '. Êtes-vous sûr de vouloir supprimer cette salle ?'

            this.$refs.confirm.open('Attention', message, { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        this.deleteRoom(index)
                    }
                })
        }
    },
    computed: {
        ...mapState('web_form', ['disabled', 'provider']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode'])
    }
}
</script>